/**
 * Oferta de reconquista de quem deixou o teste vencer há até 7 dias, sem assinar.
 * Vem de subscription/plans/get.php (winback_discount: { percent, months, until })
 * só quando a conta é elegível; o cupom é aplicado sozinho no checkout.
 */

// 'YYYY-MM-DD HH:MM:SS' -> 'DD/MM' sem passar por Date (evita virar o dia por fuso)
const formatUntil = (until) => {
  const [y, m, d] = String(until || '').slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}` : null;
};

const formatDiscountMonths = (months) =>
  (Number(months) === 1 ? 'o primeiro mês' : `os ${months} primeiros meses`);

/** Linha do card abaixo do preço: "nos 3 primeiros meses" */
export const getDiscountNote = (months) =>
  (Number(months) === 1 ? 'no primeiro mês' : `nos ${months} primeiros meses`);

/** Texto da faixa: "Assinando até 20/10, os 3 primeiros meses saem com 50% de desconto..." */
export const getWinbackDiscountText = (discount) => {
  const until = formatUntil(discount.until);
  const months = formatDiscountMonths(discount.months);
  const verb = Number(discount.months) === 1 ? 'sai' : 'saem';
  const head = until ? `Assinando até ${until}, ${months}` : `Assinando agora, ${months}`;
  return `${head} ${verb} com ${Number(discount.percent)}% de desconto, aplicado automaticamente no pagamento. Depois, segue o valor normal do plano.`;
};

/** Preço mensal com o desconto aplicado (null quando não se aplica ao plano) */
export const getDiscountedPrice = (plan, discount) => {
  if (!discount || plan.contact_sales || !(Number(plan.price) > 0)) return null;
  return Math.round(Number(plan.price) * (100 - Number(discount.percent))) / 100;
};
